import React from "react";

/**
 * BlueBrotherstech logo
 * Inspired by:
 *  - IBM-style horizontal stripe typography (clipped silhouette filled with stripes)
 *  - The "Blues Brothers" silhouette: fedora hat + wayfarer-style sunglasses
 * Stylistic inspiration only — not a copy of either mark.
 */
export const Logo = ({ className = "h-9 w-auto text-slate-50", withWordmark = true }) => {
  // 9 horizontal stripes used to fill the silhouette, IBM-style
  const stripeYs = [2, 8, 14, 20, 26, 32, 38, 44, 50];

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg
        viewBox="0 0 80 56"
        xmlns="http://www.w3.org/2000/svg"
        className="h-8 w-auto"
        aria-hidden="true"
      >
        <defs>
          <clipPath id="bb-silhouette">
            {/* Fedora crown */}
            <rect x="22" y="0" width="36" height="8" rx="2" />
            {/* Hat brim */}
            <rect x="8" y="8" width="64" height="6" rx="1" />
            {/* Sunglasses lenses */}
            <rect x="10" y="22" width="26" height="18" rx="3" />
            <rect x="44" y="22" width="26" height="18" rx="3" />
            {/* Bridge */}
            <rect x="34" y="28" width="12" height="4" />
            {/* Subtle chin line (collar) */}
            <rect x="20" y="48" width="40" height="6" rx="1" />
          </clipPath>
        </defs>
        {/* horizontal stripes only visible within the silhouette */}
        <g clipPath="url(#bb-silhouette)" fill="currentColor">
          {stripeYs.map((y) => (
            <rect key={y} x="0" y={y} width="80" height="3" />
          ))}
        </g>
      </svg>
      {withWordmark && (
        <span
          className="font-semibold tracking-tight text-slate-50"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif", letterSpacing: "-0.01em" }}
        >
          Blue<span className="text-blue-400">Brotherstech</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
